export const APP_STARTED = 'APP_STARTED';
export const INITIALIZE_AUTH = 'INITIALIZE_AUTH';
export const INITIALIZE_CONFIG = 'INITIALIZE_CONFIG';
export const QUERY_PARAM_TERM_UPDATED = 'QUERY_PARAM_TERM_UPDATED';
export const EXPERIMENTATION_SET_ELIGIBILITY = 'EXPERIMENTATION_SET_ELIGIBILITY';
export const FETCH_PER_PRODUCT_PRICING_API_STARTED = 'FETCH_PER_PRODUCT_PRICING_API_STARTED';
export const FETCH_PER_PRODUCT_PRICING_API_COMPLETED = 'FETCH_PER_PRODUCT_PRICING_API_COMPLETED';
export const FETCH_PER_PRODUCT_PRICING_API_FAILED = 'FETCH_PER_PRODUCT_PRICING_API_FAILED';
export const FETCH_PAGED_QUANTITY_PACKS_API_STARTED = 'FETCH_PAGED_QUANTITY_PACKS_API_STARTED';
export const FETCH_PAGED_QUANTITY_PACKS_API_COMPLETED = 'FETCH_PAGED_QUANTITY_PACKS_API_COMPLETED';
export const FETCH_PAGED_QUANTITY_PACKS_API_FAILED = 'FETCH_PAGED_QUANTITY_PACKS_API_FAILED';
export const PLAN_BUILDER_SYNC_CONFIGURATIONS = 'PLAN_BUILDER_SYNC_CONFIGURATIONS';
export const UPDATE_GATES = 'UPDATE_GATES';